<template>
    <div refs="plans" class="plans-component hide-scrollbar">
      <PlanUpgrade v-show="planUpgradeWizardOpen"
        :isOpened="planUpgradeWizardOpen"
        @open-dialog="planUpgradeWizardOpen = true"
        @hide-dialog="planUpgradeWizardOpen = false"
        v-on:PlanUpgradeDialogClose="handleClosePlanUpgradeDialog"/>

      <div v-show="!planUpgradeWizardOpen && !isCheckingCurrentPlan" class="hp-row content-default pt-[10px] flex items-start justify-center">
        <!-- Discovery -->
        <div class="plan discovery content-column">
          <PlanCardDiscovery/>
        </div>

        <!-- Premium -->
        <div class="plan premium content-column">
          <PlanCardPremium @get-premium-clicked="planUpgradeWizardOpen = true"/>
        </div>
      </div>
    </div>
</template>

<script src="./plans.js"></script>
<style lang="scss" src="./plans.scss"></style>
